import { CTATileData } from "@faire/deprecated-retailer-visitor-shared/components/Carousel/CTATile";
import {
  IProps,
  CarouselBase,
  BaseCarouselProps,
} from "@faire/deprecated-retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Carousel/CarouselBase";
import { Context } from "@faire/deprecated-retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Context";
import { EventOrigin } from "@faire/deprecated-retailer-visitor-shared/features/InsightsFeed/events";
import { InsightCard } from "@faire/deprecated-retailer-visitor-shared/features/InsightsFeed/InsightCard";
import { InsightCardContextProvider } from "@faire/deprecated-retailer-visitor-shared/features/InsightsFeed/InsightCardContext";
import { trackHomeFeedLayoutElementCustomItemClick } from "@faire/web-api--source/events/homeFeed/click/layoutElementCustomItem";
import { IInsightTile } from "@faire/web-api--source/indigofair/data/IInsightTile";
import myBrandsUpdates from "@faire/web-api--source/routes/www/my-brands/updates";
import { isNotUndefined } from "@faire/web/common/typescriptUtils";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";

export const InsightsCarousel: React.FC<BaseCarouselProps> = (props) => {
  const CarouselBaseComponent = CarouselBase as React.ComponentType<
    IProps<IInsightTile>
  >;
  const { layoutElement, requestId, onItemClick, onVisible } =
    React.useContext(Context);

  const handleClick = (token: string) => {
    onItemClick?.(layoutElement.on_click_event_name ?? "", requestId, token);
  };

  const handleCtaTileClick = () => {
    trackHomeFeedLayoutElementCustomItemClick(
      layoutElement.on_click_event_name ?? "",
      requestId,
      "see-all-tile"
    );
  };

  const ctaTileData: CTATileData = {
    text: (
      <StrictLocalMsg
        id="dKw82f"
        defaultMessage="Show all"
        description={{
          text: "A button to see all items in a list",
          img: "https://cdn.faire.com/fastly/237ab511431ed9481509144bcc65fe3cae4de6f09be88326f9f2a4eb222c92da.png",
        }}
      />
    ),
    linkTo: myBrandsUpdates(),
    onClick: handleCtaTileClick,
  };

  const renderItem = (tile: IInsightTile, index: number) => (
    <BottomBorderDiv key={tile?.insight_token ?? index}>
      <InsightCard asCarouselTile data={tile} />
    </BottomBorderDiv>
  );

  const items = layoutElement.layout_element_data
    .map((data) => data.insight_tile)
    .filter(isNotUndefined);

  const onItemsVisible = (items: IInsightTile[]) => {
    const itemTokens = items.map((item) => item?.insight_token);
    if (layoutElement.on_click_event_name) {
      onVisible?.(
        layoutElement.on_click_event_name,
        requestId,
        itemTokens?.join(" ") ?? ""
      );
    }
  };

  return (
    <InsightCardContextProvider
      origin={EventOrigin.HomeFeed}
      onCardClick={handleClick}
    >
      <CarouselBaseComponent
        {...props}
        renderItem={renderItem}
        items={items}
        itemsPerSlide={{
          mobileAndAbove: 1,
          tabletAndAbove: 2,
          desktopAndAbove: 3,
        }}
        itemGap={{
          mobileAndAbove: 8,
          tabletAndAbove: 16,
        }}
        ctaTileData={ctaTileData}
        peekNextPercent={{
          mobileAndAbove: 15,
          tabletAndAbove: 0,
        }}
        lateralPadding={16}
        noWrap
        onItemsVisible={onItemsVisible}
      />
    </InsightCardContextProvider>
  );
};

const BottomBorderDiv = styled.div`
  padding-bottom: 1px;
`;
